const PipelineRoutes = [
	{
		path: '/pipeline',
		component: () => import('@/components/default'),
		children: [
			{
				path: '',
				redirect: '/pipeline/contacts',
			},
			{
				path: 'dashboard',
				component: () => import('@/components/default'),
				children: [
					{
						path: '',
						name: '',
						component: () => import('@/components/pipelines/Dashboard'),
					},
				],
			},
			{
				path: 'contacts',
				component: () => import('@/components/default'),
				children: [
					{
						path: '',
						name: '',
						component: () => import('@/components/pipelines/Contacts'),
					},
					{
						path: 'add-contact',
						name: 'add-contact',
						component: () => import('@/components/pipelines/AddContact'),
					},
					{
						path: ':id?',
						name: 'contact-details',
						component: () => import('@/components/pipelines/ContactDetails'),
					},
				],
			},
			{
				path: 'leads',
				component: () => import('@/components/default'),
				children: [
					{
						path: '',
						name: '',
						component: () => import('@/components/pipelines/Leads'),
					},
					{
						path: 'add-lead',
						name: 'add-lead',
						component: () => import('@/components/pipelines/AddLead'),
					},
					{
						path: ':id?',
						name: 'lead-details',
						component: () => import('@/components/pipelines/LeadDetails'),
					},
				],
			},
		],
	},
];

export default PipelineRoutes;
